// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6203":"css/admin-app.6983","9037":"css/app.6983"}[chunkId] + ".css";
};